// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"6d258e92","667":"b847bd2e"}[chunkId] + ".chunk.js";
};